import "core-js/modules/es.object.to-string.js";
import { getRequestPriceDetailProducts, getRequestPriceStatusList as _getRequestPriceStatusList } from "@/services/order/inquiry";
export default {
  name: 'inquiryDetailProduct',
  i18n: require('../i18n-inquiry'),
  props: {
    inquiryData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    columns: function columns() {
      return [{
        title: this.$t('inquiryDetail.productNo'),
        dataIndex: 'productNo',
        width: 100
      }, {
        title: this.$t('inquiryDetail.productName'),
        dataIndex: 'productName',
        scopedSlots: {
          customRender: 'productName'
        }
      }, {
        title: this.$t('inquiryDetail.sellWay'),
        dataIndex: 'caseOrItem',
        width: 120,
        scopedSlots: {
          customRender: 'caseOrItem'
        },
        align: 'right'
      }, {
        title: this.$t('inquiryDetail.productNum'),
        dataIndex: 'productNum',
        scopedSlots: {
          customRender: 'productNum'
        },
        width: 100,
        align: 'right'
      }];
    }
  },
  data: function data() {
    return {
      productInfo: {},
      isTableLoading: false,
      orderStatusList: []
    };
  },
  mounted: function mounted() {
    this.requestPriceId = this.$route.query.id;
    this.loadProductInfo();
    this.getRequestPriceStatusList();
  },
  methods: {
    loadProductInfo: function loadProductInfo() {
      var _this = this;
      this.isTableLoading = true;
      getRequestPriceDetailProducts({
        orderId: this.requestPriceId
      }).then(function (response) {
        if (response.data.code == 200) {
          _this.productInfo = response.data.data;
          // this.orderInfo.BasicInfo = response.data.data.getInfosMainVo;
          // this.orderNoteList = response.data.data.getInfosChildVoList;
          // this.orderInfo.orderNoteList = response.data.data.getInfosChildVoList;
        }
      }).finally(function () {
        _this.isTableLoading = false;
      });
    },
    getRequestPriceStatusList: function getRequestPriceStatusList() {
      var _this2 = this;
      _getRequestPriceStatusList(this.requestPriceId).then(function (response) {
        if (response.data.code == 200) {
          _this2.orderStatusList = response.data.data;
        }
      });
    },
    getStatus: function getStatus(Status) {
      console.log(Status, 'sssssss');
      // return this.$t(`public.orderStatus${Status.orderStatus}`) + "　" + Status.createTime;
      return (Status.orderStatus == 1 ? this.$t('public.orderStatus2') : Status.orderStatus == 2 ? this.$t('public.orderStatus99') : this.$t('public.orderStatus7')) + "　" + Status.createTime;
    }
  }
};